import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';

const ForgetPassModel = ({ show, onClose }) => {
    const [email, setemail] = useState('');
    const [loading, setLoading] = useState(false); // <-- loader state

    const handleSubmitForgetPass = async (e) => {
        e.preventDefault();
        setLoading(true); // Show loader

        try {
            const response = await fetch('https://backend.indianjewelryish.com/api/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            setLoading(false); // Hide loader
            onClose();

            Swal.fire({
                icon: 'success',
                confirmButtonColor: '#b63f23',
                title: 'Forgot password link sent to your E-mail!',
            });
        } catch (error) {
            setLoading(false); // Hide loader on error too
            console.error('Error adding category:', error);
            Swal.fire({
                icon: 'error',
                confirmButtonColor: '#b63f23',
                title: 'Something went wrong. Please try again later.',
            });
        }
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton />
            <Modal.Body>
                <div className="popupcontainer">
                    <div id='fpdiv'>
                        <h1>Forget Password</h1>
                        <form id='fpform' onSubmit={handleSubmitForgetPass}>
                            <label id='fplable'>Enter Email</label>
                            <input
                                type="email"
                                placeholder='Enter E-mail'
                                value={email}
                                onChange={(e) => setemail(e.target.value)}
                                required
                            />

                            <div id='butdiv'>
                                <button className='loginsignupbutton' type='submit' disabled={loading}>
                                    {loading ? (
                                        <>
                                            <Spinner animation="border" size="sm" role="status" className="me-2" />
                                            Sending...
                                        </>
                                    ) : (
                                        'Send Email'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ForgetPassModel;
